module.exports = __webpack_public_path__ + "img/preview.45b239fa.jpg";